module.exports = __webpack_public_path__ + "static/통조림-8c266cc0d9f1e233c09b09a30d7fc46c.jpeg";